import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { actionTypes, TRaceVisualizerActions } from '../actions/raceVisualizerActions';

function getInitialState() {
  return {
    instances: []
  };
}

export default function raceVisualizerReducer(
  state: Partial<any> = getInitialState(),
  action: TRaceVisualizerActions
): Partial<any> {
  switch (action.type) {
    case actionTypes.SET_RACE_VISUALIZER_DATA: {
      const instanceId = action.payload.instanceId || 'default';
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceId]: {
            ...state.instances[instanceId],
            ...action.payload.data,
            isLoading: false,
            forceRefresh: false
          }
        }
      };
    }
    case actionTypes.SHOW_RACE_VISUALIZER_SPINNER: {
      const instanceId = action.payload.instanceId || 'default';
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceId]: {
            ...state.instances[instanceId],
            isLoading: action.payload,
            forceRefresh: false
          }
        }
      };
    }
    case actionTypes.FORCE_RACE_VISUALIZER_REFRESH: {
      const instanceId = action.payload.instanceId || 'default';
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceId]: {
            ...state.instances[instanceId],
            forceRefresh: true
          }
        }
      };
    }
    case LOCATION_CHANGE as any: {
      if ((action as any).payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return getInitialState();
    }
    default: {
      return state;
    }
  }
}
